<div fxLayout="row">
  <div fxLayout="column wrap">
    <form [formGroup]="form">
      <mat-form-field>
        <mat-label>Target role</mat-label>
        <mat-select formControlName="targetRoleSelect" placeholder="" (selectionChange)="onTargetRoleChange($event)">
          @for (item of targetRoles; track item) {
            <mat-option [value]="item.value">{{item.label}}</mat-option>
          }
        </mat-select>
        @if (!form.get('targetRoleSelect').valid) {
          <mat-error>Target role is required</mat-error>
        }
      </mat-form-field>
    </form>
  </div>
</div>

<lib-loading-overlay [isLoading]="isLoading" [message]="'loading...'" />